<template>
    <div class="app-container">

        <el-row class="navigation">
            <el-col align="left">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '' }">当前位置:</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/main/index' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '' }">NQI服务</el-breadcrumb-item>
                    <el-breadcrumb-item>认证认可</el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>
        </el-row>
        <el-row :gutter="10">
            <el-col :span="6">
                <el-row class="left-img">
                    <img src="@/assets/images/zltszhfw/rzfw/banner.png"/>
                </el-row>
                <el-row class="menu-box">
                    <div>
                        <div class="menu-level1"  @click="changeMenu('威海市资质认定检验检测机构'),changeMenu2('威海市资质认定检验检测机构','0101','机构查询')">
                                威海市资质认定检验检测机构 <span :class="menuIcon"></span>
                        </div>
                    </div>
                    <div>
                        <div class="menu-level1"  @click="changeMenu('全国认证机构查询'),changeMenu2('全国认证机构查询','0201','机构查询')">
                            全国认证机构查询 <span :class="menuIcon"><i
                                class="el-icon-link"></i></span>
                        </div>
                    </div>
                    <div>
                        <div class="menu-level1"  @click="changeMenu('全省资质认定检验检测机构查询'),changeMenu2('全省资质认定检验检测机构查询','0301','机构查询')">
                            全省资质认定检验检测机构查询 <span :class="menuIcon"><i
                                class="el-icon-link"></i></span>
                        </div>
                    </div>
                    <div v-for="(item, index) in menuList" :key="item.name">
                        <div class="menu-level1" :class="{active1:isActive==item.name}" @click="changeMenu(item.name)">
                            {{item.name}}
                            <span :class="isCollapse==item.name?menuIconDown:menuIcon"><i
                                    class="el-icon-arrow-right"></i></span>
                        </div>
                        <div v-show="isCollapse==item.name">
                            <el-row :gutter="0">
                                <el-col style="margin-bottom: 5px;text-align:left;" :span="12"
                                        v-for="(itemchild, index2) in item.labels" :key="itemchild.code">
									<span @click="changeMenu2(item.name,itemchild.code,itemchild.label)"
                                          class="menu-level2"
                                          :class="{active2:isActive2==itemchild.code}">{{itemchild.label}}
									</span>
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                    <div>
                        <div class="menu-level1"  @click="changeMenu('医疗器械产品注册资料预审'),changeMenu2('医疗器械产品注册资料预审','0601','资料预审')">
                            医疗器械产品注册资料预审 <span :class="menuIcon"></span>
                        </div>
                    </div>
                </el-row>
            </el-col>
            <el-col :span="18" class="right-box">
                <!-- 威海市资质认定检验检测机构 -->
                <el-row class="right-box-row" style="min-height: 430px;" v-show="isShow=='0101'">
                    <el-row class="right-box-row-title">
                        {{tableTitle}}
                    </el-row>
                    <el-form :model="jyjcjgQueryParams" ref="queryForm" :inline="true" style="margin-top: 10px;">
                        <el-row>
                            <el-col :span="10">
                                <el-form-item label="单位名称" prop="entname">
                                    <el-input v-model="jyjcjgQueryParams.companyName"
                                              placeholder="请输入单位名称" clearable size="small"/>
                                </el-form-item>
                            </el-col>
                            <el-col :span="10">
                                <el-form-item label="统一社会信用代码">
                                    <el-input v-model="jyjcjgQueryParams.uniscid"
                                              placeholder="请输入统一社会信用代码" clearable size="small"/>
                                </el-form-item>
                            </el-col>
                            <el-col :span="10">
                                <el-form-item label="细分类别">
                                    <el-input v-model="jyjcjgQueryParams.subCategory"
                                              placeholder="请输入细分类别" clearable size="small"/>
                                </el-form-item>
                            </el-col>
                            <!--<el-col :span="10">
                                <el-form-item label="细分类别" prop="busType">
                                    <el-select v-model="jyjcjgQueryParams.subCategory" placeholder="请选择细分类别" clearable size="small">
                                        <el-option v-for="dict in subCategorys" :key="dict.dictValue" :label="dict.dictLabel"
                                                   :value="dict.dictValue" />
                                    </el-select>
                                </el-form-item>
                            </el-col>-->
                            <el-col :span="2">
                                <el-button type="primary" size="small" @click="getJyjcjgList" style="margin-top: 3px;">检
                                    索
                                </el-button>
                            </el-col>
                        </el-row>
                    </el-form>
                    <el-table v-loading="jyjcjgLoading" :data="list" tooltip-effect="light">
                        <el-table-column align="center" prop="companyName" label="单位名称" :show-overflow-tooltip="true"/>
                        <el-table-column label="统一社会信用代码" align="center" prop="uniscid" :show-overflow-tooltip="true"/>
                        <el-table-column label="细分类别" align="center" prop="subCategory"
                                         :show-overflow-tooltip="true"/>
                        <!--<el-table-column label="产品(设备)名称" align="center" prop="productName" :show-overflow-tooltip="true"/>-->
                        <el-table-column label="经营范围" align="center" prop="natureBusiness"
                                         :show-overflow-tooltip="true"/>
                        <!--<el-table-column label="许可证类型及编号" align="center" prop="xkzlxjbh" :show-overflow-tooltip="true"/>-->
                        <el-table-column label="所属区域" align="center" prop="region" :show-overflow-tooltip="true"/>
                        <el-table-column label="地址" align="center" prop="dom" :show-overflow-tooltip="true"/>
                        <el-table-column label="联系人" align="center" prop="lxr">
                            <template slot-scope="scope">
                                <el-tag v-if="!isLoginState">登录后查看</el-tag>
                                <span v-if="isLoginState" >{{scope.row.lxr}}</span>
                            </template>
                        </el-table-column>
                        <!--<el-table-column label="联系方式" align="center" prop="tel">
                            <template slot-scope="scope">
                                <el-tag v-if="!isLoginState">登录后查看</el-tag>
                                <span v-if="isLoginState" >{{scope.row.tel}}</span>
                            </template>
                        </el-table-column>-->
                    </el-table>
                    <pagination v-show="jyjcjgTotal>0" :total="jyjcjgTotal" :page.sync="jyjcjgQueryParams.pageNum"
                                :limit.sync="jyjcjgQueryParams.pageSize" @pagination="getJyjcjgList"/>
                </el-row>

                <!-- 泰山品质通知公告 -->
                <el-row class="right-box-row" style="min-height: 430px;" v-show="isShow=='0401'">
                    <el-row class="right-box-row-title">
                        {{tableTitle}}
                    </el-row>
                    <el-form :model="tspztzggQueryParams" ref="queryForm" :inline="true"
                             style="margin-top: 10px; background-color:#D7D7D7">
                        <el-row style="border: 0px solid red;align-content: center;padding-right: 140px;padding-top: 20px">
                            <el-col :span="20" align="right">
                                <el-form-item>
                                    <el-input v-model="tspztzggQueryParams.title" style="width: 360px"
                                              placeholder="请输入标题" clearable size="small"/>
                                </el-form-item>
                                <el-button type="primary" size="small" style="margin-top: 4px" @click="getTspztzggList">
                                    检 索
                                </el-button>
                            </el-col>
                            <br>
                        </el-row>
                    </el-form>

                    <el-table v-loading="tspztzggLoading" :data="tspztzggList" :show-header="false"
                              tooltip-effect="light">
                        <el-table-column align="left" :show-overflow-tooltip="true" prop="title" class-name="title">
                            <template slot-scope="scope">
                                <span @click="openTzggDetail(scope.row,'tspz')">{{ scope.row.title }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="发布时间" align="center" prop="fbTime" :width="180">
                            <template slot-scope="scope">
                                <span>{{ parseTime(scope.row.fbTime, '{y}-{m}-{d}') }}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <pagination v-show="stqytzggTotal>0" :total="stqytzggTotal" :page.sync="stqytzggQueryParams.pageNum"
                                :limit.sync="stqytzggQueryParams.pageSize" @pagination="getStqytzggList"/>
                </el-row>

                <!-- 泰山品质网上申报 -->
                <el-row class="right-box-row" style="min-height: 430px;" v-show="isShow=='0402'">
                    <el-row class="right-box-row-title">
                        {{tableTitle}}
                    </el-row>
                    <div style="margin: 20px 0;"></div>
                    <el-descriptions title="申请企业信息">
                        <el-descriptions-item label="企业名称">{{tspzSbForm.entname}}</el-descriptions-item>
                        <el-descriptions-item label="统一社会信用代码">{{tspzSbForm.uniscid}}</el-descriptions-item>
                    </el-descriptions>
                    <el-alert
                            title="请严格依据通知公告上传所需材料"
                            show-icon
                            type="warning">
                    </el-alert>
                    <el-form ref="form" :model="tspzSbForm" label-width="80px" style="margin-top: 20px;">
                        <el-row>
                            <el-col :span="24">
								<span style="float: left;">
                                    <attachment-list-size :size="300" :listType="listType" module="zlts_rzfw_tspzsb"
                                                          :businessid="tspzSbForm.recid" :limit="limit"
                                                          :accept="accept" @isEmitFun="isEmitFun">
                                    </attachment-list-size>
								  </span>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item>
                                    <el-checkbox v-model="tspzSbForm.iscn">
                                        我承诺：我所填写的申请信息真实有效。我单位对填写的内容真实性负责，如有虚假将依法承担相应责任
                                    </el-checkbox>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-form-item>
                            <el-button type="primary" :disabled="!tspzSbForm.iscn" @click="toSubmit('tspzSb')">提交</el-button>
                        </el-form-item>
                    </el-form>
                </el-row>

                <!-- 三同通知公告 -->
                <el-row class="right-box-row" style="min-height: 430px;" v-show="isShow=='0501'">
                    <el-row class="right-box-row-title">
                        {{tableTitle}}
                    </el-row>
                    <el-form :model="stqytzggQueryParams" ref="queryForm" :inline="true"
                             style="margin-top: 10px; background-color:#D7D7D7">
                        <el-row style="border: 0px solid red;align-content: center;padding-right: 140px;padding-top: 20px">
                            <el-col :span="20" align="right">
                                <el-form-item>
                                    <el-input v-model="stqytzggQueryParams.title" style="width: 360px"
                                              placeholder="请输入标题" clearable size="small"/>
                                </el-form-item>
                                <el-button type="primary" size="small" style="margin-top: 4px" @click="getStqytzggList">
                                    检 索
                                </el-button>
                            </el-col>
                            <br>
                        </el-row>
                    </el-form>

                    <el-table v-loading="stqytzggLoading" :data="stqytzggList" :show-header="false"
                              tooltip-effect="light">
                        <el-table-column align="left" :show-overflow-tooltip="true" prop="title" class-name="title">
                            <template slot-scope="scope">
                                <span @click="openTzggDetail(scope.row,'stqy')">{{ scope.row.title }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="发布时间" align="center" prop="fbTime" :width="180">
                            <template slot-scope="scope">
                                <span>{{ parseTime(scope.row.fbTime, '{y}-{m}-{d}') }}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <pagination v-show="tspztzggTotal>0" :total="tspztzggTotal" :page.sync="tspztzggQueryParams.pageNum"
                                :limit.sync="tspztzggQueryParams.pageSize" @pagination="getTspztzggList"/>
                </el-row>

                <!-- 三同网上申报 -->
                <el-row class="right-box-row" style="min-height: 430px;" v-show="isShow=='0502'">
                    <el-row class="right-box-row-title">
                        {{tableTitle}}
                    </el-row>
                    <div style="margin: 20px 0;"></div>
                    <el-descriptions title="申请企业信息">
                        <el-descriptions-item label="企业名称">{{stqySbForm.entname}}</el-descriptions-item>
                        <el-descriptions-item label="统一社会信用代码">{{stqySbForm.uniscid}}</el-descriptions-item>
                    </el-descriptions>
                    <el-alert
                            title="请严格依据通知公告上传所需材料"
                            show-icon
                            type="warning">
                    </el-alert>
                    <el-form ref="form" :model="stqySbForm" label-width="80px" style="margin-top: 20px;">
                        <el-row>
                            <el-col :span="24">
								<span style="float: left;">
                                    <attachment-list-size :size="300" :listType="listType" module="zlts_rzfw_stqysb"
                                                          :businessid="stqySbForm.recid" :limit="limit"
                                                          :accept="accept" @isEmitFun="isEmitFun">
                                    </attachment-list-size>
								  </span>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item>
                                    <el-checkbox v-model="stqySbForm.iscn">
                                        我承诺：我所填写的申请信息真实有效。我单位对填写的内容真实性负责，如有虚假将依法承担相应责任
                                    </el-checkbox>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-form-item>
                            <el-button type="primary" :disabled="!stqySbForm.iscn" @click="toSubmit('stqySb')">提交</el-button>
                        </el-form-item>
                    </el-form>
                </el-row>

                <!-- 三同示范企业 -->
                <el-row class="right-box-row" style="min-height: 430px;" v-show="isShow=='0503'">
                    <el-row class="right-box-row-title">
                        {{tableTitle}}
                    </el-row>
                    <el-form :model="stqysfqyQueryParams" ref="queryForm" :inline="true"
                             style="margin-top: 10px; background-color:#D7D7D7">
                        <el-row style="border: 0px solid red;align-content: center;padding-right: 140px;padding-top: 20px">
                            <el-col :span="20" align="right">
                                <el-form-item>
                                    <el-input v-model="stqysfqyQueryParams.entname" style="width: 360px"
                                              placeholder="请输入标题" clearable size="small"/>
                                </el-form-item>
                                <el-button type="primary" size="small" style="margin-top: 4px" @click="getStqyFbList">
                                    检 索
                                </el-button>
                            </el-col>
                            <br>
                        </el-row>
                    </el-form>

                    <el-table v-loading="stqyfbLoading" :data="stqyfbList" :show-header="false"
                              tooltip-effect="light">
                        <el-table-column align="left" :show-overflow-tooltip="true" prop="title" class-name="title">
                            <template slot-scope="scope">
                                <span @click="openStqyFbDetail(scope.row)">{{ scope.row.entname }}</span>
                            </template>
                        </el-table-column>
                       <!-- <el-table-column label="企业网址" align="center" prop="entweb" :show-overflow-tooltip="true"/>-->
                        <!--                        <el-table-column label="企业彩页" align="center" prop="qycy":show-overflow-tooltip="true"/>-->
                        <el-table-column label="发布时间" align="center" prop="fbTime" :width="180">
                            <template slot-scope="scope">
                            <span>{{ parseTime(scope.row.fbTime, '{y}-{m}-{d}') }}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <pagination v-show="stqyfbTotal>0" :total="stqyfbTotal" :page.sync="stqysfqyQueryParams.pageNum"
                                :limit.sync="stqysfqyQueryParams.pageSize" @pagination="getStqyFbList"/>
                </el-row>

                <!-- 医疗器械产品注册资料预审 -->
                <el-row class="right-box-row" style="min-height: 430px;" v-show="isShow=='0601'">
                    <el-row class="right-box-row-title">
                        {{tableTitle}}
                    </el-row>
                    <div style="margin: 20px 0;"></div>
                    <el-descriptions title="申请企业信息">
                        <el-descriptions-item label="企业名称">{{ylqxForm.entname}}</el-descriptions-item>
                        <el-descriptions-item label="统一社会信用代码">{{ylqxForm.uniscid}}</el-descriptions-item>
                    </el-descriptions>
                    <!--<el-alert
                            title="请正确填写上传所需材料"
                            show-icon
                            type="warning">
                    </el-alert>-->
                    <el-form ref="ylqxform" :model="ylqxForm" label-width="80px" style="margin-top: 20px;" :rules="ylqxrules">
                        <el-row>

                            <el-col :span="24" align="left">
                                <el-form-item label="问题描述:" prop="regContent" label-width="85px">
                                    <el-input
                                            type="textarea"
                                            placeholder="请输入问题描述内容（产品注册申报过程中的问题，法律法规实施相关问题等，描述具体问题情况，需要进行资料预审的可以附件形式上传）"
                                            v-model="ylqxForm.regContent"
                                            maxlength="150"
                                            :autosize="{ minRows: 6, maxRows: 8}"
                                            show-word-limit>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <div style="margin: 20px 0;"></div>
                        <el-row>
                            <el-col :span="24">
								<span style="float: left;">
                                    <attachment-list-size :size="300" :listType="listType" module="zlts_rzfw_ylqxsb"
                                                          :businessid="ylqxForm.recid" :limit="ylqxLimit"
                                                          :accept="accept" @isEmitFun="isEmitFun">
                                    </attachment-list-size>
								  </span>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item>
                                    <el-checkbox v-model="ylqxForm.iscn">
                                        我承诺：我所填写的申请信息真实有效。我单位对填写的内容真实性负责，如有虚假将依法承担相应责任
                                    </el-checkbox>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-form-item>
                            <el-button type="primary" :disabled="!ylqxForm.iscn" @click="toSubmit('ylqx')">提交</el-button>
                        </el-form-item>
                    </el-form>
                </el-row>
            </el-col>
        </el-row>

    </div>
</template>

<script>
    import {listZzrdjyjcjg} from "@/api/zlts/rzfw/zzrdjyjcjg";
    import {listTspztzgg} from "@/api/zlts/rzfw/tspztzgg";
    import AttachmentListSize from "../../../components/AttachmentListSize";
    import {listStqytzgg} from "@/api/zlts/rzfw/stqytzgg";
    import router from "../../../../router";
    import {addTspzsb} from "@/api/zlts/rzfw/tspzsb";
    import {addStqysb} from "@/api/zlts/rzfw/stqysb";
    import {addYlqx,getYlqxsb} from "@/api/zlts/rzfw/ylqx";
    import {listStqyfb} from "@/api/zlts/rzfw/stqyfb";
    import {updatePvNum} from "@/api/itempv/pv";

    export default {
        name: "rzfw",
        components: {
            AttachmentListSize,
        },
        data() {
            return {
                // 遮罩层
                loading: false,
                jyjcjgLoading: false,
                tspztzggLoading: false,
                stqytzggLoading: false,
                stqyfbLoading: false,
                // 总条数
                total: 0,
                jyjcjgTotal: 0,
                tspztzggTotal: 0,
                stqytzggTotal: 0,
                stqyfbTotal: 0,
                // 是否显示弹出层
                open: false,
                // 查询参数
                time: undefined,
                menuIcon: 'menu-icon',
                menuIconDown: 'menu-icon-down',
                menuList: [
                    {
                        name: '泰山品质认证',
                        labels: [{
                            label: '通知公告',
                            url: 'zscqzhfw/flfgzc',
                            code: "0401"
                        }, {
                            label: '网上申报',
                            url: 'zscqzhfw/fwlmjj',
                            code: "0402"
                        }]

                    },
                    {
                        name: '威海市"三同"企业',
                        labels: [{
                            label: '通知公告',
                            url: 'zscqzhfw/flfgzc',
                            code: "0501"
                        }, {
                            label: '网上申报',
                            url: 'zscqzhfw/fwlmjj',
                            code: "0502"
                        }, {
                            label: '示范企业',
                            url: 'zscqzhfw/zscqcs',
                            code: "0503"
                        }]
                    }
                ],
                isActive: "威海市资质认定检验检测机构",
                isActive2: "0101",
                isCollapse: "威海市资质认定检验检测机构",
                list: [],
                tspztzggList: [],
                stqytzggList: [],
                stqyfbList: [],
                queryParams: {
                    pageNum: 1,
                    pageSize: 10
                },
                tspztzggQueryParams: {
                    pageNum: 1,
                    pageSize: 10
                },
                stqytzggQueryParams: {
                    pageNum: 1,
                    pageSize: 10
                },
				stqysfqyQueryParams: {
				    pageNum: 1,
				    pageSize: 10
				},
                jyjcjgQueryParams: {
                    pageNum: 1,
                    pageSize: 10,
                    companyName: undefined,
                    uniscid: undefined,
                },
                tableTitle: "威海市资质认定检验检测机构查询",
                isShow: '0101',
                tspzSbForm: {
                    recid: undefined,
                    entname: undefined,
                    uniscid: undefined,
                    type: 'tspzSb',
                    iscn: false,
                    ywFwjgRecid:undefined,
                },
                stqySbForm: {
                    recid: undefined,
                    entname: undefined,
                    uniscid: undefined,
                    type: 'stqySb',
                    iscn: false,
                    ywFwjgRecid:undefined,
                },
                //医疗器械form
                ylqxForm: {
                    recid: undefined,
                    entname: undefined,
                    uniscid: undefined,
                    iscn: false,
                    type: 'ylqx',
                    ywFwjgRecid:undefined,
                    regContent:undefined,
                },
                rules: {

                },
                ylqxrules:{
                  regContent: [ { type: 'string',required: true,message: "请输入问题描述内容", trigger: 'blur'}, {max: 150,message: "长度不能超过150" }]
                },
                limit: 10,
                //医疗器械上传附件限制一个附件
                ylqxLimit:1,
                //组件是否上传
                isUpload: false,
                categorys: [],
                subCategorys: [],
                listType: 'text',
                accept: ".doc, .docx, .xls, .xlsx, .pdf, .jpg, .png",
                isLoginState:undefined,
				
            };
        },
        created() {
            this.loginUser = JSON.parse(localStorage.getItem("sdtyfwpt_loginuser"));
            // console.log(this.loginUser)
            if(this.loginUser != null && this.loginUser != undefined){
                this.tspzSbForm.entname= this.loginUser.corname;
                this.tspzSbForm.uniscid = this.loginUser.cornumber;
                this.tspzSbForm.ywFwjgRecid = this.loginUser.ywFwjgRecid;
                this.stqySbForm.uniscid = this.loginUser.cornumber;
                this.stqySbForm.entname= this.loginUser.corname;
                this.stqySbForm.ywFwjgRecid = this.loginUser.ywFwjgRecid;
                this.ylqxForm.uniscid = this.loginUser.cornumber;
                this.ylqxForm.entname= this.loginUser.corname;
                this.ylqxForm.ywFwjgRecid = this.loginUser.ywFwjgRecid;
            }
            this.getDicts("jyjcjg_category").then(response => {
                this.categorys = response.data;
            });
            this.getDicts("jyjcjg_sub_category").then(response => {
                this.subCategorys = response.data;
            });
            this.resetData();
            this.getJyjcjgList();
            this.inits();
        },
        methods: {
            resetData(){
                this.tspzSbForm.recid= this.randomString();
                this.tspzSbForm.iscn=false;
                this.stqySbForm.recid= this.randomString();
                this.stqySbForm.iscn=false;
                this.ylqxForm.recid= this.randomString();
                this.ylqxForm.iscn=false;
                this.ylqxForm.regContent=undefined;

            },
            isEmitFun(str) {
                if (str > 0) {
                    this.isUpload = true;
                } else {
                    this.isUpload = false;
                }
            },
            categorysFormat(row, column) {
                return this.selectDictLabel(this.categorys, row.category);
            },
            subCategorysFormat(row, column) {
                return this.selectDictLabel(this.subCategorys, row.subCategory);
            },
            inits(){
                let indexToRzfwCode = sessionStorage.getItem("indexToRzfwCode");
                if(indexToRzfwCode != null && indexToRzfwCode !='' && indexToRzfwCode != undefined){
                    if(indexToRzfwCode =='0501'){
                        this.changeMenuLink('威海市"三同"企业');
                        this.changeMenuLink2('威海市"三同"企业','0501','通知公告');
                    }else if(indexToRzfwCode =='0401'){
                        this.changeMenuLink("泰山品质认证");
                        this.changeMenuLink2('泰山品质认证','0401','通知公告');
                    }else if(indexToRzfwCode =='0601'){
                        this.changeMenuLink("医疗器械产品注册资料预审");
                        this.changeMenuLink2('医疗器械产品注册资料预审','0601','医疗器械产品注册资料预审');
                        // let indexToRzfwRegContent = sessionStorage.getItem("indexToRzfwRegContent");
                        let indexToRzfwRecid = sessionStorage.getItem("indexToRzfwRecid");
                        getYlqxsb(indexToRzfwRecid).then(response =>{
                            // console.log("response",response.data)
                            this.ylqxForm.regContent=response.data.regContent;
                            // console.log("this.ylqxForm",this.ylqxForm)
                            // sessionStorage.setItem("indexToRzfwRegContent",response.data.regContent);
                        });
                        this.ylqxForm.recid =indexToRzfwRecid;
                        // this.ylqxForm.regContent = indexToRzfwRegContent;
                        // console.log("indexToRzfwRegContent",indexToRzfwRegContent)
                    }
                }
            },
            changeMenuLink(name, code) {
                this.isCollapse = name;
                this.isActive = name;
                this.isActive2 = undefined;
            },
            changeMenuLink2(name, code, name2) {
                this.isActive = name;
                this.isActive2 = code;
                if (code === '0201') {
                    updatePvNum("zlts_rzrk_qgrzjgcx").then(response => {
                        //pv 点击全国认证机构查询
                    });
                    window.open("http://cx.cnca.cn/CertECloud/institutionBody/authenticetionList");
                } else if (code === '0301') {
                    updatePvNum("zlts_rzrk_qszzrdjyjcjgcx").then(response => {
                        //pv 点击全省资质认定检验检测机构查询
                    });
                    window.open("http://amr.shandong.gov.cn/col/col92838/index.html");
                } else if (code === '0101') {
                    this.getJyjcjgList();
                    this.isShow = code;
                    this.tableTitle = name + "查询";
                    updatePvNum("zlts_rzrk_whszzrdjyjcjgcx").then(response => {
                        //pv 点击威海市资质认定检验检测机构
                    });

                } else if (code === '0401') {
                    this.isShow = code;
                    this.tableTitle = name + name2;
                    this.getTspztzggList();
                    updatePvNum("zlts_rzrk_tspzrztzgg").then(response => {
                        //pv 点击泰山品质认证通知公告
                    });
                } else if (code === '0402') {//申报
                    this.isShow = code;
                    this.tableTitle = name + name2;
                    updatePvNum("zlts_rzrk_tspzrzwssb").then(response => {
                        //pv 点击泰山品质认证网上申报
                    });
                } else if (code === '0501') {
                    this.isShow = '0501';
                    this.tableTitle = name + name2;
                    this.getStqytzggList();
                    updatePvNum("zlts_rzrk_whsstqytzgg").then(response => {
                        //pv 点击威海市"三同"企业知公告
                    });
                } else if (code === '0502') {//申报
                    this.isShow = '0502';
                    this.tableTitle = name + name2;
                    updatePvNum("zlts_rzrk_whsstqywssb").then(response => {
                        //pv 点击威海市'三同'企业网上申报
                    });
                } else if (code === '0503') {
                    this.isShow = '0503';
                    this.tableTitle = name + name2;
                    this.getStqyFbList();
                    updatePvNum("zlts_rzrk_whsstqysfqy").then(response => {
                        //pv 点击威海市'三同'企业示范企业
                    });
                }else if (code ==="0601"){
                    this.isShow="0601";
                    this.tableTitle = name;
                    updatePvNum("zlts_rzrk_ylqxcpzczlys").then(response => {
                        //pv 点击医疗器械产品注册资料预审
                    });
                }
            },
            changeMenu(name, code) {
                this.isCollapse = name;
                this.isActive = name;
                this.isActive2 = undefined;
            },
            changeMenu2(name, code, name2) {
                if(!(code =='0501' || code =='0401' || code =='0601')){
                    //如果点击其他页面，需要清空缓存
                    this.resetData();
                    sessionStorage.removeItem("indexToRzfwCode");
                    sessionStorage.removeItem("indexToRzfwRecid");
                }
                this.isActive = name;
                this.isActive2 = code;
                if (code === '0201') {
                    updatePvNum("zlts_rzrk_qgrzjgcx").then(response => {
                        //pv 点击全国认证机构查询
                    });
                    window.open("http://cx.cnca.cn/CertECloud/institutionBody/authenticetionList");
                } else if (code === '0301') {
                    updatePvNum("zlts_rzrk_qszzrdjyjcjgcx").then(response => {
                        //pv 点击全省资质认定检验检测机构查询
                    });
                    window.open("http://amr.shandong.gov.cn/col/col92838/index.html");
                } else if (code === '0101') {
                    this.getJyjcjgList();
                    this.isShow = code;
                    this.tableTitle = name + "查询";
                    updatePvNum("zlts_rzrk_whszzrdjyjcjgcx").then(response => {
                        //pv 点击威海市资质认定检验检测机构
                    });

                } else if (code === '0401') {
                    this.isShow = code;
                    this.tableTitle = name + name2;
                    this.getTspztzggList();
                    updatePvNum("zlts_rzrk_tspzrztzgg").then(response => {
                        //pv 点击泰山品质认证通知公告
                    });
                } else if (code === '0402') {//申报
                    this.isShow = code;
                    this.tableTitle = name + name2;
                    updatePvNum("zlts_rzrk_tspzrzwssb").then(response => {
                        //pv 点击泰山品质认证网上申报
                    });
                } else if (code === '0501') {
                    this.isShow = '0501';
                    this.tableTitle = name + name2;
                    this.getStqytzggList();
                    updatePvNum("zlts_rzrk_whsstqytzgg").then(response => {
                        //pv 点击威海市"三同"企业知公告
                    });
                } else if (code === '0502') {//申报
                    this.isShow = '0502';
                    this.tableTitle = name + name2;
                    updatePvNum("zlts_rzrk_whsstqywssb").then(response => {
                        //pv 点击威海市'三同'企业网上申报
                    });
                } else if (code === '0503') {
                    this.isShow = '0503';
                    this.tableTitle = name + name2;
                    this.getStqyFbList();
                    updatePvNum("zlts_rzrk_whsstqysfqy").then(response => {
                        //pv 点击威海市'三同'企业示范企业
                    });
                }else if (code ==="0601"){
                    this.isShow="0601";
                    this.tableTitle = name;
                    updatePvNum("zlts_rzrk_ylqxcpzczlys").then(response => {
                        //pv 点击医疗器械产品注册资料预审
                    });
                }
            },
            //查询检验检测机构
            getJyjcjgList() {
				//----【】需要修改为recid
				let ssessionLoginUser = JSON.parse(localStorage.getItem('ssessionLoginUser'));
				if (ssessionLoginUser != null && ssessionLoginUser.islogin) {
					this.isLoginState = true;
				} else {
					this.isLoginState = false;
				}
                this.jyjcjgLoading = true;
                listZzrdjyjcjg(this.jyjcjgQueryParams).then(response => {
                    this.list = response.rows;
                    this.jyjcjgTotal = response.total;
                    this.jyjcjgLoading = false;
                });
            },
            //查询泰山品质通知公告
            getTspztzggList() {
                this.tspztzggLoading = true;
                listTspztzgg(this.tspztzggQueryParams).then(response => {
                    this.tspztzggList = response.rows;
                    this.tspztzggTotal = response.total;
                    this.tspztzggLoading = false;
                });
            },
            //查询威海市'三同'企业示范企业
            getStqyFbList() {
                this.stqyfbLoading = true;
                listStqyfb(this.stqysfqyQueryParams).then(response => {
                    this.stqyfbList = response.rows;
                    this.stqyfbTotal = response.total;
                    this.stqyfbLoading = false;
                });
            },
            /** 泰山品质申报提交按钮 */
            tspzSbSubmit() {
                this.$refs["form"].validate(valid => {
                    if (valid) {
                        if (this.isUpload) {
                            if (this.tspzSbForm.iscn) {
                                this.$confirm('是否提交并申报？', '提示', {
                                    confirmButtonText: '确定',
                                    cancelButtonText: '取消',
                                    type: 'warning'
                                }).then(() => {
                                    // console.log(this.tspzSbForm)
                                    addTspzsb(this.tspzSbForm).then(response => {
                                        if (response.code === 200) {
                                            this.msgSuccess("申报成功");
                                           // this.$router.back();
                                            this.resetData();
                                        } else {
                                            this.msgError(response.msg);
                                        }
                                    });
                                })
                            } else {
                                this.msgError("请选择承诺");
                            }
                        } else {
                            this.msgError("请上传附件");
                        }
                    }
                })
            },
            toSubmit(type){
				if (this.utils.isLoginTimeout()) {
					let ssessionLoginUser = JSON.parse(localStorage.getItem('ssessionLoginUser'));
					if(ssessionLoginUser != null && ssessionLoginUser != undefined){
					    let ywFwjg = ssessionLoginUser.ywFwjg;
					    if(ywFwjg == null){
					        this.msgWarning('参数有误！');
					        this.resetData();
					        return false;
                        }
					    if(ssessionLoginUser.user.ywFwjgRecid === null || ssessionLoginUser.user.ywFwjgRecid ==="" || ssessionLoginUser.user.ywFwjgRecid===undefined){
                            this.msgWarning('参数有误！');
                            this.resetData();
                            return false;
                        }
					    if(ywFwjg.userType ==='1'){
                            this.msgWarning('您不是企业用户，不能操作此业务！');
                            this.resetData();
					        return false;
                        }
                        if(ywFwjg.userType ==='2' && ywFwjg.entcat==='2'){
                            this.msgWarning('您不是企业用户，不能操作此业务！');
                            this.resetData();
                            return false;
                        }else{
                            this.tspzSbForm.ywFwjgRecid = ssessionLoginUser.user.ywFwjgRecid;
                            this.stqySbForm.ywFwjgRecid = ssessionLoginUser.user.ywFwjgRecid;
                            this.ylqxForm.ywFwjgRecid = ssessionLoginUser.user.ywFwjgRecid;
                            if(type=='tspzSb'){
                                //泰山品质认证申报
                                this.tspzSbSubmit();
                            }else if(type=='stqySb'){
                                //三同申报
                                this.stqySbSubmit();
                            }else if(type=='ylqx'){
                                //医疗器械
                                this.ylqxSubmit();
                            }
                        }
					}
				} else {
					this.$confirm('您未登录或登录已过期，您可以继续留在该页面，或者重新登录?', '提示', {
					    confirmButtonText: '确定',
					    cancelButtonText: '取消',
					    type: 'warning'
					}).then(() => {
					    this.logout(this.ywFwjgRecid)
					})
				}
            },
            /** 三同品质申报提交按钮 */
            stqySbSubmit() {

                this.$refs["form"].validate(valid => {
                    if (valid) {
                        if (this.isUpload) {
                            if (this.stqySbForm.iscn) {
                                this.$confirm('是否提交并申报？', '提示', {
                                    confirmButtonText: '确定',
                                    cancelButtonText: '取消',
                                    type: 'warning'
                                }).then(() => {
                                  console.log(this.stqySbForm)
                                    addStqysb(this.stqySbForm).then(response => {
                                        if (response.code === 200) {
                                            this.msgSuccess("申报成功");
                                            //this.$router.back();
                                            this.resetData();
                                        } else {
                                            this.msgError(response.msg);
                                        }
                                    });
                                })
                            } else {
                                this.msgError("请选择承诺");
                            }
                        } else {
                            this.msgError("请上传附件");
                        }
                    }
                })
            },
            /** 医疗器械提交按钮 */
            ylqxSubmit() {
                this.$refs["ylqxform"].validate(valid => {
                    if (valid) {
                        // if (this.isUpload) {
                            if (this.ylqxForm.iscn) {
                                this.$confirm('是否提交？', '提示', {
                                    confirmButtonText: '确定',
                                    cancelButtonText: '取消',
                                    type: 'warning'
                                }).then(() => {
                                    addYlqx(this.ylqxForm).then(response => {
                                        if (response.code === 200) {
                                            this.msgSuccess("提交成功");
                                            //this.$router.back();
                                            this.resetData();
                                            sessionStorage.removeItem("indexToRzfwCode");
                                            // sessionStorage.removeItem("indexToRzfwRegContent");
                                            sessionStorage.removeItem("indexToRzfwRecid");
                                        } else {
                                            this.msgError(response.msg);
                                        }
                                    });
                                })
                            } else {
                                this.msgError("请选择承诺");
                            }
                        // } else {
                        //     this.msgError("请上传附件");
                        // }
                    }
                })
            },
            //查询三同企业通知公告
            getStqytzggList() {
                this.stqytzggLoading = true;
                listStqytzgg(this.stqytzggQueryParams).then(response => {
                    this.stqytzggList = response.rows;
                    this.stqytzggTotal = response.total;
                    this.stqytzggLoading = false;
                });
            },
            //打开通知公告详情
            openTzggDetail(item,tableName) {
                let routerUrl = this.$router.resolve({
                    path: "/main/zltszhfw/rzfw/tzggDetail",
                    query: {recid:item.recid+':'+tableName}
                });
                window.open(routerUrl.href, '_blank');
                // this.utils.windowOpen('/main/zltszhfw/rzfw/tzggDetail' + '/' + item.recid+':'+tableName);
            },
            //打开三通企业发布详情
            openStqyFbDetail(item) {
                if(item.entweb ==='' || item.entweb==null || item.entweb===undefined) {
                    let routerUrl = this.$router.resolve({
                        path: "/main/zltszhfw/rzfw/StqyFbDetail",
                        query: {recid: item.recid}
                    });
                    window.open(routerUrl.href, '_blank');
                }else{
                    window.open(item.entweb, '_blank');
                }
            }
        }
    }
</script>

<style scoped>
    .app-container {
        padding: 10px;
        background-color: #ffffff;
    }

    .navigation {
        padding: 20px 15px;
        line-height: 20px;
        height: 60px;
        background-color: #F5F5F5;
        margin-bottom: 15px;
    }

    .left-img img {
        width: 100%;
    }

    .menu-box {
        background-color: #FAFAFA;
        padding: 15px 10px;
    }

    .el-collapse-item {
        background-color: #1482F0;
    }

    .menu-level1 {
        padding: 10px;
        background-color: #eeeeee;
        padding-left: 20px;
        font-size: 13px;
        text-align: left;
        margin-bottom: 10px;
        margin-top: 10px;
        cursor: pointer;
        /*font-weight: 500;*/
        /*font-family: "arial black";*/
    }

    .active1 {
        color: #55aaff;
        background-color: rgb(235, 239, 248);
    }

    .menu-icon {
        float: right;

    }

    .menu-icon-down {
        float: right;
        transform: rotate(90deg);
    }

    .menu-level2 {
        padding: 5px 20px 5px 20px;

        font-size: 12px;
        font-weight: 500;
        cursor: pointer;
    }

    .active2 {
        color: rgb(255, 208, 75);
    }

    .right-box {
        padding-left: 10px;
    }

    .right-box-row {
        border: 1px solid #cccccc;
        padding: 0px 15px 0;
    }

    .right-box-row-title {
        padding: 15px 0;
        text-align: left;
        color: #409eff;
        font-size: 18px;
        font-weight: bold;
        border-bottom: 1px solid #cccccc;
        margin: 0px 0;
    }

    /deep/ .title:hover {
        color: #1482f0;
        cursor: pointer;
    }

    .el-table .cell {
        white-space: pre-line
    }

    .fileTypeClass {
        color: #8492a6;
        font-size: 10px;
        border: 0px solid red;
        padding-right: 260px;
    }

    /deep/ .el-checkbox__label {
        color: #ffaa20;
    }
</style>
